import moment from 'moment'

const toTimeStamp = time => time && time.length ? [moment(time[0]).valueOf(), moment(time[1]).valueOf()] : []
const parseDate = (date, format) => !date ? null : moment(date).format(format)

export {
  toTimeStamp,
  parseDate
}
